/*
|-------------------------------------------------------------------------------
| 个人信息1
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

/**
 * store
 */
const PersonInfoStore = defineStore({
  state: () => ({
    page: '', // 后端返回的页面标识
    // 用户所填字段信息
    fields: {
      email: '',//邮箱
      occupation: '',//职业
      education: 0, // 教育程度
      monthIncome: '', // 月收入
      // 家庭住址
      familyAddress: {
        postcode: '', // 邮编
        postcodeId: '', // colonia
        streetInfo: '', // 街道门牌号
      },
    },
  }),
  mutations: {
    updatePage(state, data) {
      state.page = data
    },
    updateFields(state, data) {
      Object.assign(state.fields, data)
    },
    updateFamilyAddress(state, data) {
      Object.assign(state.fields?.familyAddress, data)
    },
    update(state, data) {
      data && Object.assign(state, data)
    },
  },
})

export default PersonInfoStore
export type IPersonInfoStoreState = IStoreState<
  typeof PersonInfoStore.state
>
